import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  :root {
    --head: 'Segoe UI', 'Segoe', system-ui, -apple-system, sans-serif;
    --body: 'Open Sans', sans-serif;
    --hand: 'Caveat', cursive;
  }
`;
